export default "/images/vendor/pannellum-react/es/pannellum/css/grab.svg?6a052e927d39314632fd6836ceedf303";